import styled, { css } from 'styled-components';

import { normalizedTranslate } from '../../utils';

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${(p) => p.theme.token('height-tabs')};
  position: relative;
`;

export const TabsWrapper = styled.div`
  display: flex;
`;

export const Underline = styled.span<{ tabSlideWidth: number; idx: number }>`
  height: 3px;
  background-color: ${(p) => p.theme.token('background-active')};
  width: ${(p) => `${p.tabSlideWidth}%`};
  transform: ${(p) => normalizedTranslate(`${100 * p.idx}%`)};
  transition: ${(p) => p.theme.token('transition-component')};
  position: absolute;
  inset-block-end: 0;
`;

export const StyledTab = styled.button<{ disabled?: boolean; $selected?: boolean }>`
  width: 100%;
  height: ${(p) => p.theme.token('height-tabs')};
  background-color: transparent;
  border: none;
  border-block-end: 1px solid ${(p) => p.theme.token('border-color-default')};
  transition: ${(p) => p.theme.token('transition-component')};
  font: ${(p) => p.theme.token('text-style-tabs')};
  &:focus {
    background-color: ${(p) => p.theme.token('background-focus')};
    outline: none;
  }
  &:not(:focus-visible) {
    background-color: transparent;
  }
  &:focus-visible {
    background-color: ${(p) => p.theme.token('background-focus')};
  }

  ${(p) =>
    !p.disabled &&
    !p.$selected &&
    css`
      &:hover {
        border-block-end: 1px solid ${p.theme.token('border-color-hover')};
      }
    `}

  ${({ disabled, theme: { token } }) => {
    if (disabled) {
      return css`
        color: ${token('text-disabled')};
        cursor: not-allowed;
      `;
    }
    return css`
      color: ${token('text-default')};
      cursor: pointer;
    `;
  }}
`;

export const StyledTabPanel = styled.div<{ $selected?: boolean }>`
  display: ${(p) => (p.$selected ? 'flex' : 'none')};
  position: relative;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  /** Shows no outline on click
    * Falls back to showing outline on click in browsers
    * that do not support :focus-visible (e.g., Safari)
    */

  &:focus {
    outline: none;
    box-shadow: ${(p) => p.theme.token('box-shadow-pattern')};
  }

  &:not(:focus-visible) {
    box-shadow: none;
  }

  &:focus-visible {
    box-shadow: ${(p) => p.theme.token('box-shadow-pattern')};
  }
`;
